import cn from "classnames";
import React from "react";

import { IconSizes } from "@2u-landing-pages/types";
import styles from "./Icon.module.scss";

interface IconProps {
  pack?: "feather";
  name: string;
  size?: IconSizes;
  className?: string;
  style?: React.CSSProperties;
}

export const Icon: React.FC<IconProps> = ({ pack = "feather", name, size = "md", className, style, ...rest }) => {
  return <i className={cn(pack, `icon-${name}`, styles[size], className)} style={style} {...rest} />;
};
